import TABLE_KEY from './table-key';

export const getDataTableStorageKeyPrefix = (name: string) => `${name}_filter`;

export const getSortStatusStorageKey = (name: string) =>
  `${getDataTableStorageKeyPrefix(name)}_sortStatus`;

export const getFilterStatusStorageKey = (name: string) =>
  `${getDataTableStorageKeyPrefix(name)}_filter_status_key`;

const STORAGE_KEYS = {
  // common
  COMMON_DATE_FILTER: 'COMMON_DATE_FILTER',

  // feedback list
  FEEDBACK_FILTER_STATUS_KEY: getFilterStatusStorageKey(
    TABLE_KEY.FEEDBACK_TABLE_KEY,
  ),

  SHOW_CHART: 'SHOW_CHART',
  SHOW_FEEDBACK_COUNT: 'SHOW_FEEDBACK_COUNT',

  AGENT_FILTER_STATUS_KEY: 'AGENT_FILTER_STATUS_KEY',

  // feedback detail
  FEEDBACK_DETAIL_FULL_VIEW: 'FEEDBACK_DETAIL_FULL_VIEW',
  FEEDBACK_DETAIL_COLLAPSE_PROPERTY_KEY:
    'FEEDBACK_DETAIL_COLLAPSE_PROPERTY_KEY',
  FEEDBACK_DETAIL_SHOW_CONTACT_FEED_ONLY_KEY:
    'FEEDBACK_DETAIL_SHOW_CONTACT_FEED_ONLY_KEY',

  // Sidebar
  SIDEBAR_STATE: 'SIDEBAR_STATE',

  // theme
  SYNCLY_COLOR_MODE: 'COLOR_MODE',

  // customer
  CUSTOMER_VIEW_FILTER_STATE: 'customer_view_filter_state',
  CUSTOMER_VIEW_FILTER_STATE_DATE_RANGE:
    'customer_view_filter_state_date_range',
  CUSTOMER_VIEW_HIDE_NEUTRAL: 'customer_view_hide_neutral',

  // Taxonomy
  TAXONOMY_TOPIC_TREE_STATE: 'TAXONOMY_TOPIC_TREE_STATE',
  TOPIC_DETAIL_GUIDE_STATE: 'TOPIC_DETAIL_GUIDE_STATE',

  // Navigator
  NAVIGATOR_HISTORY: 'NAVIGATOR_HISTORY',

  // Insight explorer
  INSIGHT_EXPLORER_SENTIMENT_GUIDE: 'INSIGHT_EXPLORER_SENTIMENT_GUIDE',
  INSIGHT_EXPLORER_DATE_FILTER: 'INSIGHT_EXPLORER_DATE_FILTER',

  // Signal custom chart
  SIGNAL_CUSTOM_CHART_STATE: 'SIGNAL_CUSTOM_CHART_STATE',

  // Listening query scraper health
  LISTENING_QUERY_SCRAPER_HEALTH: 'LISTENING_QUERY_SCRAPER_HEALTH',
};

export default STORAGE_KEYS;

export const COLUMN_CONFIG_KEY = 'column_config_key';
export const RESET_COLUMN_KEY = 'reset_column_key'; // column config 초기화 키
export const RESET_STORAGE_KEY = 'reset_storage_key'; // local storage 전체 초기화 키
